import Vue from 'vue'
import {isEmpty, dateFormat} from '../utils/commonUtil'
// 时间转换
Vue.filter('dateFormat', (time, format = 'yyyy-MM-dd') => {
  if(!isEmpty(time)) return dateFormat(time, format)
})
// 字段类型匹配
Vue.filter('fieldFilter', (resObj, mappingItem) => {
  if(mappingItem.type === 'empty') {
    return ''
  }
  if(!isEmpty(resObj[mappingItem.value]) || [true, false].includes(resObj[mappingItem.value])) {
    let type = mappingItem.type
    let value = resObj[mappingItem.value]
    switch (type) {
      case 'decimal':
        let fixed = !isEmpty(mappingItem.fixed) ? mappingItem.fixed : 2
        value = parseFloat(value).toFixed(fixed)
        return value
      case 'money':
        let fixed1 = !isEmpty(mappingItem.fixed) ? mappingItem.fixed : 2
        return '￥' + parseFloat(value).toFixed(fixed1).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
      case 'date':
        if(!isEmpty(value)) return dateFormat(value)
        return value
      case 'datetime':
        if(!isEmpty(value)) return dateFormat(value, 'yyyy-MM-dd hh:mm')
        return value
      case 'boolean':
        let str = value
        if(value === true) str = '是'
        if(value === false) str = '否'
        return str
      case 'select':
      case 'lookups':
        return resObj[`${mappingItem.value}_text`]
      default:
        return value
    }
  }
  return '--'
})
Vue.filter('fieldFilterEmpty', (resObj, mappingItem) => {
  if(mappingItem.type === 'empty') {
    return ''
  }
  if(!isEmpty(resObj[mappingItem.value]) || [true, false].includes(resObj[mappingItem.value])) {
    let type = mappingItem.type
    let value = resObj[mappingItem.value]
    switch (type) {
      case 'decimal':
        let fixed = !isEmpty(mappingItem.fixed) ? mappingItem.fixed : 2
        value = parseFloat(value).toFixed(fixed)
        return value
      case 'money':
        let fixed1 = !isEmpty(mappingItem.fixed) ? mappingItem.fixed : 2
        return '￥' + parseFloat(value).toFixed(fixed1).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
      case 'date':
        if(!isEmpty(value)) return dateFormat(value)
        return value
      case 'datetime':
        if(!isEmpty(value)) return dateFormat(value, 'yyyy-MM-dd hh:mm')
        return value
      case 'boolean':
        let str = value
        if(value === true) str = '是'
        if(value === false) str = '否'
        return str
      case 'select':
      case 'lookups':
        return resObj[`${mappingItem.value}_text`]
      default:
        return value
    }
  }
  return ''
})
Vue.filter('fieldFilterItem', (value, type) => {
  if(!isEmpty(value) || [true, false].includes(value)) {
    switch (type) {
      case 'decimal':
        value = parseFloat(value).toFixed(2)
        return value
      case 'date':
        if(!isEmpty(value)) return dateFormat(value)
        return value
      case 'datetime':
        if(!isEmpty(value)) return dateFormat(value, 'yyyy-MM-dd hh:mm')
        return value
      case 'boolean':
        let str = value
        if(value === true) str = '是'
        if(value === false) str = '否'
        return str
      default:
        return value
    }
  }
  return '--'
})
// 去除html元素
Vue.filter('delHtmlTag', (str) => {
  return !isEmpty(str) ? str.replace(/<[^>]+>/g, '') : '--'
})
// 保留两位小数
Vue.filter('decimalFilter', (str) => {
  return parseFloat(str).toFixed(2)
})



// WEBPACK FOOTER //
// ./src/utils/filters.js